import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Grid, Card, CardContent,useMediaQuery } from "@mui/material";
import Box from "@mui/material/Box";

import { DataGrid } from "@mui/x-data-grid";
import {
  getActivityDetails,
  getDashboardStatistics,
} from "../reducers/DashboardThunk";
import moment from "moment";

const webColumns = [
  {
    field: "institution_alias_name",
    headerName: "Organization name",
    width: 150,
    flex: 1,
    renderCell: (params) => (
      <span className="wrapper">
        {params.row.institution_alias_name ? (
          <span>{params.row.institution_alias_name}</span>
        ) : (
          <span>{params.row.admin_hospital_name}</span>
        )}
      </span>
    ),
  },
  {
    field: "activity",
    headerName: "Activity Type",
    width: 150,
    flex: 1,
    renderCell: (params) => (
      <span className="wrapper">{params.row.activity}</span>
    ),
  },
  {
    field: "user_name",
    headerName: "User",
    sortable: false,
    width: 160,
    flex: 2,
    renderCell: (params) => (
      <span className="wrapper">{params.row.user_name}</span>
    ),
  },
  {
    field: "createdAt",
    headerName: "Activity Date",
    type: "number",
    width: 110,
    flex: 1,
    renderCell: (params) => (
      <span className="wrapper">
        {moment(params.row.createdAt).format("DD - MM - YY")}
      </span>
    ),
  },

  {
    field: "createdTime",
    headerName: "Activity Time",
    type: "number",
    width: 110,
    flex: 1,
    renderCell: (params) => (
      <span className="wrapper">
        {moment(params.row.createdAt).format("hh:mm:ss")}
      </span>
    ),
  },
];

const mobileColumns = [
  {
    field: "institution_alias_name",
    headerName: "Organization name",
    width: 150,
    flex: 2,
    renderCell: (params) => (
      <span className="wrapper">
        {params.row.institution_alias_name ? (
          <span>{params.row.institution_alias_name}</span>
        ) : (
          <span>{params.row.admin_hospital_name}</span>
        )}
      </span>
    ),
  },
  {
    field: "activity",
    headerName: "Activity Type",
    width: 150,
    flex: 1.5,
    renderCell: (params) => (
      <span className="wrapper">{params.row.activity}</span>
    ),
  },
  {
    field: "user_name",
    headerName: "User",
    sortable: false,
    width: 160,
    flex: 2,
    renderCell: (params) => (
      <span className="wrapper">{params.row.user_name}</span>
    ),
  },
  {
    field: "createdAt",
    headerName: "Date & Time",
    type: "number",
    width: 110,
    flex: 2,
    renderCell: (params) => (
      <span className="wrapper">
        {moment(params.row.createdAt).format("DD - MM - YY")}
        <div
            className="wrapper"
            style={{ textAlign: "center", color: "#6A6A6A", fontWeight: 400 }}
          >{moment(params.row.createdAt).format("hh:mm:ss")}</div>
      </span>
    ),
  },
];

const DashboardScreen = () => {
  const dispatch = useDispatch();

  const [activities, setActivities] = React.useState([]);
  const [dashboardStatistics, setDashboardStatistics] = React.useState();
    const isMobile = useMediaQuery('(max-width:768px)');

  const user = sessionStorage.getItem("user");

  useEffect(() => {
    //const user_id = user ? JSON.parse(user).user_id : "";
    const req = "";
    dispatch(getActivityDetails(req))
      .unwrap()
      .then((resdata) => {
        setActivities(resdata?.response.activities);
      });
  }, [user]);

  useEffect(() => {
    dispatch(getDashboardStatistics())
      .unwrap()
      .then((resdata) => {
        setDashboardStatistics(resdata?.response);
      });
  }, [user]);

  return (
    <React.Fragment>
      <div className={isMobile ? 'dataOutletIsMobile' : 'dataoutlet'}>
        <Grid container>
          <Grid item xs={12} sm={12}>
            <div className="formSection">
              <Card variant="none" style={{ background: "#eeeeee" }}>
                <CardContent style={{padding:"0px 0px"}}>
                  <Grid container>
                    <Grid item xs={12} sm={2}>
                      <Card
                        variant="none"
                        style={{ margin: "5px", padding: "0px" }}
                      >
                        <CardContent style={{ margin: "0px", padding:"5px 0px"}}>
                          <div
                            className="dashboard-header-title"
                            style={{
                              textAlign: "center",
                              fontSize: "1.3em",
                              color: "#878787",
                            }}
                          >
                            Organizations : {isMobile && dashboardStatistics?.orgs}
                            </div>
                            {!isMobile && 
                            <>
                         <br /> <div
                            className="dashboard-header-value"
                            style={{ color: "#000000" }}
                          >
                            {dashboardStatistics?.orgs}
                          </div>
                          </>
                            }
                        </CardContent>
                      </Card>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                       <Card
                        variant="none"
                        style={{ margin: "5px", padding: "0px" }}
                      >
                        <CardContent style={{ margin: "0px", padding:"5px 0px"}}>
                          <div
                            className="dashboard-header-title"
                            style={{
                              textAlign: "center",
                              fontSize: "1.3em",
                              color: "#878787",
                            }}
                          >
                            Users : {isMobile && dashboardStatistics?.users}
                             </div>
                            {!isMobile && 
                            <>
                          <br />
                          <div
                            className="dashboard-header-value"
                            style={{ color: "#000000" }}
                          >
                            {dashboardStatistics?.users}
                          </div> 
                          </>
                            }
                        </CardContent>
                      </Card>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                       <Card
                        variant="none"
                        style={{ margin: "5px", padding: "0px" }}
                      >
                        <CardContent style={{ margin: "0px", padding:"5px 0px"}}>
                          <div
                            className="dashboard-header-title"
                            style={{
                              textAlign: "center",
                              fontSize: "1.3em",
                              color: "#878787",
                            }}
                          >
                            Active Patients :{isMobile && dashboardStatistics?.bmrs}
                             </div>
                            {!isMobile && 
                            <>
                          <br />
                          <div
                            className="dashboard-header-value"
                            style={{ color: "#000000" }}
                          >
                            {dashboardStatistics?.bmrs}
                          </div>
                          </>
                          }
                        </CardContent>
                      </Card>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                       <Card
                        variant="none"
                        style={{ margin: "5px", padding: "0px" }}
                      >
                        <CardContent style={{ margin: "0px", padding:"5px 0px"}}>
                          <div
                            className="dashboard-header-title"
                            style={{
                              textAlign: "center",
                              fontSize: "1.3em",
                              color: "#878787",
                            }}
                          >
                            Discharged Patients :{isMobile && dashboardStatistics?.discharged}
                             </div>
                            {!isMobile && 
                            <>
                          <br />
                          <div
                            className="dashboard-header-value"
                            style={{ color: "#000000" }}
                          >
                            {dashboardStatistics?.discharged}
                          </div>
                          </>
                          }
                        </CardContent>
                      </Card>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                       <Card
                        variant="none"
                        style={{ margin: "5px", padding: "0px" }}
                      >
                        <CardContent style={{ margin: "0px", padding:"5px 0px"}}>
                          <div
                            className="dashboard-header-title"
                            style={{
                              textAlign: "center",
                              fontSize: "1.3em",
                              color: "#878787",
                            }}
                          >
                            Sepsis Positive Patients :{isMobile && dashboardStatistics?.positiveSepsis}
                             </div>
                            {!isMobile && 
                            <>
                          <br />
                          <div
                            className="dashboard-header-value"
                            style={{ color: "#000000" }}
                          >
                            {dashboardStatistics?.positiveSepsis}
                          </div>
                          </>
                          }
                        </CardContent>
                      </Card>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                      <Card
                        variant="none"
                        style={{ margin: "5px", padding: "0px" }}
                      >
                        <CardContent style={{ margin: "0px", padding:"5px 0px"}}>
                          <div
                            className="dashboard-header-title"
                            style={{
                              textAlign: "center",
                              fontSize: "1.3em",
                              color: "#878787",
                            }}
                          >
                            Readings : {isMobile && dashboardStatistics?.readings}
                             </div>
                            {!isMobile && 
                            <>
                          <br />
                          <div
                            className="dashboard-header-value"
                            style={{ color: "#000000" }}
                          >
                            {dashboardStatistics?.readings}
                          </div>
                          </>
                          }
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </div>
          </Grid>
        </Grid>

        <div className="formSection">
          <Card variant="none">
            <CardContent style={{padding:"2px 5px"}}>
              <Grid container>
                <Grid item xs={12} sm={12}>
                  <p className="dashboard-title" style={{fontSize:isMobile && "12px"}}>
                    Timeline of the last 10 activities
                  </p>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={12} sm={12}>
                  <div style={{ height: 630, width: "100%" }}>
                    <DataGrid
                      rows={activities}
                      columns={isMobile ? mobileColumns : webColumns}
                      showCellRightBorder={true}
                      showColumnRightBorder={true}
                      pageSize={10}
                    />
                  </div>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DashboardScreen;
